import Typography from "components/basic/typography";

/** A bulleted list inside a legal page section. */
const LegalList: React.FC<{ items: React.ReactNode[] }> = ({ items }) => (
  <Typography
    variant="body1"
    component="li"
    sx={{ marginBottom: 2, paddingLeft: 0, listStyle: "none" }}
  >
    <ul style={{ margin: 0, paddingLeft: "1.25rem" }}>
      {items.map((item, index) => (
        <li key={index} style={{ marginBottom: "0.5rem" }}>
          {item}
        </li>
      ))}
    </ul>
  </Typography>
);

export default LegalList;
